(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-new-arrivals"]) return;
  try {
    
  if (document.querySelector('.rg-new-arrivals')) {
    document.title = 'New Arrivals | Remy Gerega';
    const arrivalUrl = new URL(window.location.href);
    const wrongSort = arrivalUrl.searchParams.get('sort_by') !== 'created-descending';
    const filtered = Array.from(arrivalUrl.searchParams.keys()).some(key => key.startsWith('filter.') || key === 'page');
    if (wrongSort || filtered) {
      arrivalUrl.searchParams.set('sort_by', 'created-descending');
      Array.from(arrivalUrl.searchParams.keys()).forEach(key => { if (key.startsWith('filter.') || key === 'page') arrivalUrl.searchParams.delete(key); });
      window.location.replace(arrivalUrl.href);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
